module.exports = __webpack_public_path__ + "static/media/gold.c14ab8c3.png";